// extracted by mini-css-extract-plugin
module.exports = {"default":"SinglePostGrid--default--2JxcI"};